import useUploadFile from './useUploadFile';

export default useUploadFile;
